<app-display-card>
  <div
    class="row justify-content-between align-items-center"
    (click)="collapse = !collapse"
  >
    <div class="col-4">
      <h3>{{ getPolicyHeaderText() }}</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{ collapse ? 'up' : 'down' }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  @if (complianceSettingForms) {
    <div class="inner-panel rounded" [(ngbCollapse)]="collapse">
      @if (!collapse) {
        <div class="row mx-2">
          <div class="col">
            <div class="row">
              <div class="col-3"></div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3 d-flex flex-column">
                  <label class="form-label align-self-center">{{
                    form && form.controls.riskLevel.value === 0
                      ? 'Global'
                      : 'Risk Level ' + form.controls.riskLevel.value
                  }}</label>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">Policy Required?</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-check-group mt-0">
                      <input
                        id="workersCompensation_policyRequired{{
                          form.controls.id.value
                        }}"
                        type="checkbox"
                        class="form-check-input"
                        (change)="onWorkersCompensationIsRequiredChange()"
                        formControlName="workersCompensation_isRequired"
                      />
                      <label
                        for="workersCompensation_policyRequired{{
                          form.controls.id.value
                        }}"
                        class="form-check-label"
                        >Required?</label
                      >
                    </div>
                  </form>
                </div>
              }
            </div>
            @if (company && company.country !== 'CA') {
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">A.M. Best Rating</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="workersCompensation_amBestRating"
                        >
                          @for (
                            item of amBestValueMap
                              | keyvalue: keyValuePairDefaultOrder;
                            track item
                          ) {
                            <option [ngValue]="item.value">
                              {{ item.key }}
                            </option>
                          }
                        </select>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label"
                    >Waive Non-Rated A.M. Best Rating Carriers?</label
                  >
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-check-group">
                        <input
                          id="workersCompensation_AllowNRRatedAMBestCarriers{{
                            form.controls.id.value
                          }}"
                          type="checkbox"
                          class="form-check-input"
                          formControlName="workersCompensation_AllowNRRatedAMBestCarriers"
                        />
                        <label
                          for="workersCompensation_AllowNRRatedAMBestCarriers{{
                            form.controls.id.value
                          }}"
                          class="form-check-label"
                          >Waive</label
                        >
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">A.M. Best Financial Size</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="workersCompensation_financialSizeCategory"
                        >
                          @for (
                            item of amBestFinancialValueMap
                              | keyvalue: keyValuePairDefaultOrder;
                            track item
                          ) {
                            <option [ngValue]="item.value.value">
                              {{ item.key }}
                            </option>
                          }
                        </select>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">E.L. (Each Accident)</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-text">$</span>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Amount"
                            [inputMask]="currencyMask"
                            (ngModelChange)="
                              applyCurrencyFormat(
                                form.controls[
                                  'workersCompensation_eachIncidentEmployersLimit'
                                ],
                                $event
                              )
                            "
                            [formControl]="
                              form.controls[
                                'workersCompensation_eachIncidentEmployersLimit'
                              ]
                            "
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">E.L. (Each Employee)</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-text">$</span>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Amount"
                            [inputMask]="currencyMask"
                            (ngModelChange)="
                              applyCurrencyFormat(
                                form.controls[
                                  'workersCompensation_eachEmployeeMinimum'
                                ],
                                $event
                              )
                            "
                            [formControl]="
                              form.controls[
                                'workersCompensation_eachEmployeeMinimum'
                              ]
                            "
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">E.L. Policy Limit</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-text">$</span>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Amount"
                            [inputMask]="currencyMask"
                            (ngModelChange)="
                              applyCurrencyFormat(
                                form.controls[
                                  'workersCompensation_eachEmployerMinimum'
                                ],
                                $event
                              )
                            "
                            [formControl]="
                              form.controls[
                                'workersCompensation_eachEmployerMinimum'
                              ]
                            "
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                }
              </div>
              @for (
                item of checkBoxFields | keyvalue: keyValuePairDefaultOrder;
                track item
              ) {
                @if (item.value.show) {
                  <div class="row py-2">
                    <div class="col-3">
                      <label class="form-label">{{ item.key }}</label>
                    </div>
                    @for (form of complianceSettingForms; track form) {
                      <div class="col-3">
                        <form [formGroup]="form">
                          <div class="form-check-group">
                            <input
                              id="{{ item.key + '_' + form.controls.id.value }}"
                              type="checkbox"
                              class="form-check-input"
                              formControlName="{{ item.value.controlName }}"
                            />
                            <label
                              for="{{
                                item.key + '_' + form.controls.id.value
                              }}"
                              class="form-check-label"
                              >{{
                                item.value.labelText
                                  ? item.value.labelText
                                  : 'Required?'
                              }}</label
                            >
                          </div>
                        </form>
                      </div>
                    }
                  </div>
                }
              }
              <ng-container>
                <div class="row py-2">
                  <div class="col-3">
                    <label class="form-label"
                      >Workers Compensation Exemptions</label
                    >
                  </div>
                  @for (form of complianceSettingForms; track form) {
                    <div class="col-3">
                      <div class="form-check-group">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          (ngModelChange)="
                            disallowWCExemptionsModelChange(form, $event)
                          "
                          [ngModel]="
                            ComplianceSettingToDisallowWCExemptionsModel.get(
                              form
                            )!
                          "
                          [disabled]="
                            form.controls['disallowWCExemptions'].disabled
                          "
                        />
                        <label class="ps-2 m-0 form-check-label"
                          >Allowed?</label
                        >
                      </div>
                    </div>
                  }
                </div>
              </ng-container>
            }
          </div>
        </div>
      }
    </div>
  }
</app-display-card>
